// Original ahcut primitive (no upstream component): the official app icon + "ahcut" wordmark (ui/DESIGN.md §7).

import type { ComponentProps } from "react";
import { cn } from "@/lib/cn";

const SIZES = {
  md: { px: 28, img: "size-7", text: "text-xl" },
  lg: { px: 40, img: "size-10", text: "text-3xl" },
} as const;

export interface LogoProps extends ComponentProps<"span"> {
  size?: keyof typeof SIZES;
}

export function Logo({ size = "md", className, ...rest }: LogoProps) {
  const s = SIZES[size];
  return (
    <span data-slot="logo" className={cn("inline-flex items-center gap-2 text-fg-0", className)} {...rest}>
      {/* Decorative: the wordmark next to it carries the name. */}
      <img
        src="/favicon.png"
        srcSet="/favicon.png 1x, /apple-touch-icon.png 2x"
        width={s.px}
        height={s.px}
        alt=""
        className={cn("shrink-0", s.img)}
      />
      <span className={cn("font-display leading-none font-semibold", s.text)}>ahcut</span>
    </span>
  );
}
